import { render, staticRenderFns } from "./TextInputMaxCharacter.vue?vue&type=template&id=36bab462&scoped=true&"
import script from "./TextInputMaxCharacter.vue?vue&type=script&lang=ts&"
export * from "./TextInputMaxCharacter.vue?vue&type=script&lang=ts&"
import style0 from "./TextInputMaxCharacter.vue?vue&type=style&index=0&id=36bab462&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bab462",
  null
  
)

export default component.exports